import { Component, computed } from "@angular/core";
import { ErrorCardComponent } from "../error-card/error-card.component";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.css"],
  standalone: true,
  imports: [ErrorCardComponent],
})
export class PageNotFoundComponent {

  // Example facts about LipidCompass functions and pages to display on the 404 page
  private lipidCompassFunctionFacts = [
    {
      fact: "Explore the complete lipid database by searching lipids by name, abbreviation, or exact mass. Browse the full lipid hierarchy with links to LIPID MAPS and SwissLipids.",
      reference: "Lipid Search - Search & browse lipids",
      url: "/lipid"
    },
    {
      fact: "Browse studies filtered by organism, tissue, or disease. Access associated datasets and download mzTab-M results for your research.",
      reference: "Studies - Explore studies & datasets",
      url: "/study"
    },
    {
      fact: "Compare lipid quantities across multiple datasets side-by-side. Identify reference ranges across tissues and biological conditions.",
      reference: "Datasets - Visualize lipid quantities",
      url: "/dataset"
    },
    {
      fact: "Upload your own lipidomics data and submit it for review. The submission workflow includes validation and quality control steps.",
      reference: "Data Submission - Upload & submit data",
      url: "/submit"
    },
    {
      fact: "View the latest news, data releases, software updates, events, and publications related to LipidCompass.",
      reference: "News & Updates - Stay informed",
      url: "/news"
    },
    {
      fact: "Get comprehensive information about the LipidCompass project, including data sources, methodologies, and citations.",
      reference: "Info - Learn about LipidCompass",
      url: "/info"
    },
    {
      fact: "Access help and FAQ documentation on LipidCompass features.",
      reference: "Help - Get assistance",
      url: "/help"
    },
    {
      fact: "View the home dashboard with database statistics, composition overview, and recent news updates at a glance.",
      reference: "Home - Dashboard overview",
      url: "/"
    }
  ];

  readonly randomFact = computed(() => {
    return this.getRandomLipidCompassFact();
  });

  // add a "Did you know?" section about one of the LipidCompasss pages and functions to the 404 page, to make it more engaging
  getRandomLipidCompassFact() {
    // convert to HTML string with reference and link
    // Highlight title and reference in bold, and make the URL a clickable link
    const randomIndex = Math.floor(Math.random() * this.lipidCompassFunctionFacts.length);
    var fact = this.lipidCompassFunctionFacts[randomIndex];
    return `<p><strong>${fact.fact}</strong></p><p><em><a href="${fact.url}">${fact.reference}</a></em></p>`;
  }
}
